import { $enum } from 'ts-enum-util'
import { ILoadBoardPostState, ILoadBoardPost } from 'types/loadBoardPosts'
import uuid from 'uuid'
import { capitalize } from 'utils/capitalize'
import { DAT_EQUIPMENT_TYPES } from '../constants/loadBoardPosts'

export const convertLbpApiToState = (post: ILoadBoardPost, withUuid = false) =>
  ({
    ...post,
    origin: {
      city: capitalize(post.origin.city),
      state: post.origin.stateCode,
    },
    destination: {
      city: capitalize(post.destination.city),
      state: post.destination.stateCode,
    },
    equipmentType:
      DAT_EQUIPMENT_TYPES[$enum(DAT_EQUIPMENT_TYPES).getKeyOrDefault(post.equipmentType, 'VAN')],
    uuid: withUuid ? uuid() : undefined,
  } as ILoadBoardPostState)

export const convertLbpApiArrToPostsState = (posts: ILoadBoardPost[]) =>
  posts.map(currActivePost => ({ ...convertLbpApiToState(currActivePost, true), uuid: uuid() }))

export const mergeCommonPostAttrs = (
  activePosts: ILoadBoardPostState[],
  commonPost: ILoadBoardPostState
) =>
  activePosts.map(activePost => ({
    ...activePost,
    origin: {
      city: activePost.origin.city,
      stateCode: activePost.origin.state,
    },
    destination: {
      city: activePost.destination.city,
      stateCode: activePost.destination.state,
    },
    rate: commonPost.rate,
    pickupDate: commonPost.pickupDate,
    commentsTwo: commonPost.commentsTwo,
  }))
